export { version } from './src/package.js'
import { leaflet_topojson } from './src/leaflet-utils.js'

if (typeof L !== 'undefined')
  L.TopoJSON = L.GeoJSON.extend({
    addData: leaflet_topojson
  })
